// extracted by mini-css-extract-plugin
module.exports = {"small":"ProjectListItemIcons_small__3RHnK"};